import { useState, useEffect } from "react";
import { useGlobalContext } from "../../Context/GlobalContext";
import { User, FormField } from "../../Types";
import { Form } from "../../Components/form";
import { countryOptions } from "../../Lib/Countries"
import Notify from "../../Utils/Notify";

const Account = () => {
    const { dbManager } = useGlobalContext();

    const [countries, setCountries] = useState<{ key: string, value: string }[]>([]);
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState<User>(dbManager.user ?? {
        first_name: '',
        last_name: '',
        email: '',
        country: '',
    });
    const [countryName, setCountryName] = useState('');

    useEffect(() => {
        const getCountries = async () => {
            const countryList = await countryOptions()
            setCountries(countryList);
            if(user.country) setCountryName(countryList.find((c: any) => c.value === user.country).key);
        }

        getCountries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const setField = (field: keyof User, value: string) => {
        setUser({
            ...user,
            [field]: value,
        });
    };

    const save = async () => {
        setLoading(true);
        if(await dbManager.saveUser(user)) {
            Notify('success', 'User Saved Successfully')
        } else {
            Notify('error', 'Error Saving User')
        }
        setLoading(false);
    }

    const fields: FormField[] = [
        {
            name: "first_name",
            label: "First Name",
            type: "text",
            value: user.first_name,
            setValue: (value: string) => setField("first_name", value),
        },
        {
            name: "last_name",
            label: "Last Name",
            type: "text",
            required: false,
            value: user.last_name,
            setValue: (value: string) => setField("last_name", value),
        },
        {
            name: "email",
            label: "Email",
            type: "email",
            value: user.email,
            setValue: (value: string) => setField("email", value),
        },
        {
            name: "country",
            label: "Country",
            type: "select",
            values: countries,
            value: user.country,
            setValue: (value: string) => setField("country", value),
            filterable: true,
            startKey: countryName
        },
    ];

    return (
        <div>
            <div style={{ marginBottom: '50px', fontSize: '1.2vw' }}>MY ACCOUNT</div>
            <div className="my-account">
                <Form
                    fields={fields}
                    submit={save}
                    buttonText="Save Account"
                    buttonClass="account-button"
                    buttonWrapperClass="account-button-wrapper"
                    loading={loading}
                    horizontal={true}
                />
            </div>
        </div>
    );
};

export default Account;